import React from "react";
import { PayoutHistoryRow } from "./payout-history-row";

export function PayoutHistoryList({ rows }) {
  if (!rows.length) {
    return (
      <p className="my-0 py-10 text-center text-[14px] font-medium text-[#9CA3AF]">
        No payouts match your search.
      </p>
    );
  }

  return (
    <div className="min-w-0 overflow-hidden">
      {rows.map((row) => (
        <PayoutHistoryRow key={row.id} row={row} />
      ))}
    </div>
  );
}
